export enum BaseItemSize {
  SMALL = 'small',
  NORMAL = 'normal'
}

export enum BaseItemColor {
  gray = 'gray',
  blue = 'blue'
}
